import { FiClock, FiChevronRight } from "react-icons/fi";
import './recentticket.css';
import { useNavigate } from "react-router-dom";

const RecentTickets = () => {
  const navigate = useNavigate();
  return (
    <div className="rf-recentticket-card">
      {/* Header */}
      <div className="rf-recentticket-header">
        <h4>Recent Tickets</h4>
        <span className="rf-recentticket-badge">1 Active</span>
      </div>

      {/* Ticket list */}
      <div className="rf-recentticket-body">
        <div className="rf-recentticket-item">
          <div className="rf-recentticket-left">
            <FiClock className="rf-recentticket-icon" />
            <div className="rf-recentticket-info">
              <p className="rf-recentticket-id">#TK-8821</p>
              <p className="rf-recentticket-title">Payment Issue</p>
              <span className="rf-recentticket-status warning">In Review</span>
              <p className="rf-recentticket-updated">Last updated: 2 hours ago</p>
            </div>
          </div>
          <FiChevronRight className="rf-recentticket-arrow" />
        </div>
      </div>
       <button onClick={()=>navigate('/supports/ticket/create')} className="rf-recentticket-btn">Create Tickets</button>
      <button onClick={()=>navigate('/supports/ticket/list')} className="rf-recentticket-btn">View All Tickets</button>
    </div>
  );
};

export default RecentTickets;
